import React, { useContext, useState } from 'react';
import * as S from './styled';
import Form from '../..';
import { ExportContext } from '../../../../provider/ExportProvider';

export default function FormLogisticDelete() {
  const { setModal, setInvoice, getInvoice, deleteLogistics, deleteLogisticOrigins } =
    useContext(ExportContext)!.controllers.logistic;

  const [loading, setLoading] = useState(false);

  const selectedLogistic = getInvoice('selected.logistic');
  const selectedLogistics = getInvoice('selecteds.logistics');
  const logisticIds =
    selectedLogistic !== -1 ? [selectedLogistic] : selectedLogistics;
  const logisticLength = logisticIds.length;

  const selectedLogisticOrigin = getInvoice('selected.logisticOrigin');
  const selectedLogisticOrigins = getInvoice('selecteds.logisticOrigins');
  const logisticOriginIds =
    selectedLogisticOrigin !== -1 ? [selectedLogisticOrigin] : selectedLogisticOrigins;
  const logisticOriginLength = logisticOriginIds.length;
  const length = logisticLength + logisticOriginLength;

  const close = () => {
    setModal('single.deleteLogistics', false);
    setInvoice('selected.logistic', -1);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    Promise.all([
      ...(logisticLength > 0 ? [deleteLogistics(logisticIds)] : []),
      ...(logisticOriginLength > 0 ? [deleteLogisticOrigins(logisticOriginIds)] : [])
    ])
      .then(() => {
        close();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <S.Form
      style={{
        maxHeight: '30vh',
      }}
      onSubmit={onSubmit}
    >
      <S.Body>
        <div style={{ marginLeft: '20px' }}>
          {length === 1
            ? 'Tem certeza que deseja excluir o registro?'
            : `Tem certeza que deseja excluir ${length} registros?`}
        </div>
      </S.Body>
      <S.Actions>
        <Form.Button type="button" onClick={close}>
          Fechar
        </Form.Button>
        <Form.Button loading={loading}>Excluir</Form.Button>
      </S.Actions>
    </S.Form>
  );
}
